import { render, staticRenderFns } from "./HistoryForStages.vue?vue&type=template&id=61cb16f7&scoped=true&"
import script from "./HistoryForStages.vue?vue&type=script&lang=js&"
export * from "./HistoryForStages.vue?vue&type=script&lang=js&"
import style0 from "./HistoryForStages.vue?vue&type=style&index=0&id=61cb16f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cb16f7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VChip,VDivider,VIcon,VListItem})
